import preventMultiTouch from './utils/preventMultiTouch'
import isTouchSupported  from './utils/isTouchSupported'
import preventTouchMove  from './utils/preventTouchMove'

const touch = {
  isTouchSupported,
  preventTouchMove,
  preventMultiTouch
}

export default touch
